/* dermesHub: prezent za zakupy — drabinka progów w koszyku (portal, 2026-09-22).
 * Jeden plik: czysta logika (stanDocelowy, drabinka) + obsługa koszyka w motywie Hyper.
 * Ten sam plik czytają testy (test/prezent.test.js) i instalator w Workerze (POST /api/prezenty/motyw),
 * który wgrywa go do motywu jako assets/dermeshub-prezent.js.
 *
 * Zasada bezpieczeństwa: skrypt tylko DODAJE i ZDEJMUJE pozycje; cenę 0,01 zł pilnuje natywny rabat
 * automatyczny Shopify (Buy X get Y). Gdy skrypt nie działa, klient nie dostaje prezentu — nigdy
 * nie dostaje go taniej bez spełnionego progu. Pusta konfiguracja (metapole sklepu
 * dermeshub.prezenty) = skrypt nic nie robi.
 */
(function () {
  'use strict';

  function zl(n) {
    var s = (Math.round(n * 100) / 100).toFixed(2).replace('.', ',');
    return s.replace(/,00$/, '') + ' zł';
  }
  function progiPosortowane(konfig) {
    return (konfig && konfig.progi ? konfig.progi.slice() : []).filter(function (p) { return p && p.prog > 0; })
      .sort(function (a, b) { return a.prog - b.prog; });
  }
  // mapa: id wariantu (liczba) → { prog, typ } dla wszystkich pozycji prezentowych z konfiguracji
  function mapaWariantow(konfig) {
    var m = {};
    progiPosortowane(konfig).forEach(function (p) {
      if (p.typ === 'probki' && p.wariant) m[String(p.wariant)] = { prog: p.prog, typ: 'probki' };
      if (p.typ === 'prezent') {
        (p.opcje || []).forEach(function (o) { if (o.wariant) m[String(o.wariant)] = { prog: p.prog, typ: 'prezent' }; });
        if (p.probki_wariant) m[String(p.probki_wariant)] = { prog: p.prog, typ: 'probki' };   // próbki jako wariant produktu progu
      }
    });
    return m;
  }

  // opcje progu, które można dać: bez `brak` z portalu i bez wariantów, których Shopify nie sprzeda
  function dostepneOpcje(prog, niedostepne) {
    var nd = (niedostepne || []).map(String);
    return ((prog && prog.opcje) || []).filter(function (o) { return o.wariant && !o.brak && nd.indexOf(String(o.wariant)) < 0; });
  }

  /**
   * Stan docelowy koszyka. cart = odpowiedź /cart.js (items: key, variant_id, quantity,
   * final_line_price w groszach; discount_codes), konfig = metapole, wybor = id wariantu
   * wybranego przez klienta (albo null). Zwraca listę działań, bez efektów ubocznych.
   */
  function stanDocelowy(cart, konfig, wybor, opcje) {
    var rezygnacja = !!(opcje && opcje.rezygnacja);
    var progi = progiPosortowane(konfig), mapa = mapaWariantow(konfig);
    var items = (cart && cart.items) || [];
    var suma = 0, prezentowe = [];
    items.forEach(function (it) {
      var m = mapa[String(it.variant_id)];
      if (m) prezentowe.push({ key: it.key, wariant: it.variant_id, quantity: it.quantity, prog: m.prog, typ: m.typ, cena: it.final_line_price });
      else suma += (it.final_line_price || 0);
    });
    suma = Math.round(suma) / 100;
    var kod = ((cart && cart.discount_codes) || []).some(function (c) { return c && c.applicable !== false; });
    var st = { suma: suma, kod: kod, rezygnacja: rezygnacja, dodaj: [], usun: [], ilosc: [], probki: false, osiagniety: null, wybrany: null };
    if (kod || rezygnacja) {
      // kod rabatowy albo świadoma rezygnacja (klient chce użyć kodu w kasie): prezent wypada (nie łączy się z kodami), a próbki
      // ZOSTAJĄ jako produkt progu próbek — jego rabat łączy się z kodami (decyzja Kamila 2026-09-22, opcja 2). Próbki-wariant
      // produktu prezentu wypadają, bo należą do rabatu prezentu.
      // Kod, który NIE łączy się z rabatami produktowymi (np. WITAJ5: productDiscounts=false), zostawiłby próbki w pełnej cenie —
      // linia próbek droższa niż 1 gr/szt. przy kodzie = odrzucone: zdejmujemy i nie dokładamy, dopóki kody się nie zmienią
      // (opcje.probkiOdrzucone pamięta przeglądarka per zestaw kodów).
      var pr = progi.filter(function (p) { return p.typ === 'probki' && p.wariant; })[0];
      var celK = pr && suma >= pr.prog && !(opcje && opcje.probkiOdrzucone) ? String(pr.wariant) : null, jestK = false;
      prezentowe.forEach(function (l) {
        if (celK && !jestK && l.typ === 'probki' && String(l.wariant) === celK) {
          if (kod && l.cena > l.quantity) { st.probki_odrzucone = true; st.usun.push(l.key); celK = null; return; }
          jestK = true; if (l.quantity !== 1) st.ilosc.push({ key: l.key, quantity: 1 });
        } else st.usun.push(l.key);
      });
      if (celK && !jestK) st.dodaj.push({ id: Number(celK), prog: pr.prog });
      st.probki = !!celK;
      return st;
    }
    // prezent: jeden, z najwyższego osiągniętego progu (decyzja Kamila 2026-09-22: bez kumulacji)
    var osiagniety = null;
    progi.forEach(function (p) { if (p.typ === 'prezent' && (p.opcje || []).length && suma >= p.prog) osiagniety = p; });
    // prezent bez towaru (2026-09-24): `brak` z metapola (portal co godzinę wg Subiektu DC i BL) albo `niedostepne` z przeglądarki
    // (Shopify odmówił dodania / wariant niedostępny w /products/<handle>.js) — nie wybieramy go i zdejmujemy z koszyka.
    // Opcje progu zawierają też prezenty z niższych progów, więc pusta lista = w tej chwili nie ma czego dać.
    var opcjeProgu = osiagniety ? dostepneOpcje(osiagniety, opcje && opcje.niedostepne).map(function (o) { return String(o.wariant); }) : [];
    var zPrezentem = osiagniety && opcjeProgu.length;
    // pakiet próbek: dokładnie jedna linia, gdy próg osiągnięty. Po osiągnięciu progu prezentu próbki muszą być
    // WARIANTEM produktu tego progu (rabat progu obejmuje prezent + próbki; osobny rabat próbek nie łączy się z nim).
    // Bez dostępnego prezentu próbki zostają produktem progu 150 (jego rabat działa przy każdej kwocie od 150 zł).
    var probki = progi.filter(function (p) { return p.typ === 'probki' && p.wariant; })[0];
    var linieProbek = prezentowe.filter(function (l) { return l.typ === 'probki'; });
    var celProbek = zPrezentem && osiagniety.probki_wariant ? String(osiagniety.probki_wariant) : (probki && suma >= probki.prog ? String(probki.wariant) : null);
    if (celProbek) {
      st.probki = true;
      var jestP = false;
      linieProbek.forEach(function (l) {
        if (!jestP && String(l.wariant) === celProbek) { jestP = true; if (l.quantity !== 1) st.ilosc.push({ key: l.key, quantity: 1 }); }
        else st.usun.push(l.key);
      });
      if (!jestP) st.dodaj.push({ id: Number(celProbek), prog: probki ? probki.prog : osiagniety.prog });
    } else linieProbek.forEach(function (l) { st.usun.push(l.key); });
    var linieP = prezentowe.filter(function (l) { return l.typ === 'prezent'; });
    if (!osiagniety) { linieP.forEach(function (l) { st.usun.push(l.key); }); return st; }
    st.osiagniety = osiagniety.prog;
    if (!zPrezentem) { st.brak_prezentu = true; linieP.forEach(function (l) { st.usun.push(l.key); }); return st; }
    var cel = null;
    if (wybor && opcjeProgu.indexOf(String(wybor)) >= 0) cel = String(wybor);
    else {
      var zTego = linieP.filter(function (l) { return l.prog === osiagniety.prog && opcjeProgu.indexOf(String(l.wariant)) >= 0; })[0];
      cel = zTego ? String(zTego.wariant) : opcjeProgu[0];
    }
    var jest = false;
    linieP.forEach(function (l) {
      if (!jest && String(l.wariant) === cel) { jest = true; if (l.quantity !== 1) st.ilosc.push({ key: l.key, quantity: 1 }); }
      else st.usun.push(l.key);
    });
    if (!jest) st.dodaj.push({ id: Number(cel), prog: osiagniety.prog });
    st.wybrany = Number(cel);
    return st;
  }

  /** Drabinka do paska: co zdobyte, co następne i ile brakuje. suma w zł. */
  function drabinka(suma, konfig) {
    var progi = progiPosortowane(konfig);
    var zdobyte = [], nastepny = null;
    progi.forEach(function (p) { if (suma >= p.prog) zdobyte.push(p); else if (!nastepny) nastepny = p; });
    var n = progi.length, procent = 0;
    if (n) {
      // odcinki równej długości między kamieniami: kamień k stoi na (k+1)/n
      var k = zdobyte.length, dolny = k ? progi[k - 1].prog : 0, gorny = k < n ? progi[k].prog : null;
      var czesc = gorny == null ? 1 : Math.max(0, Math.min(1, (suma - dolny) / (gorny - dolny)));
      procent = Math.round(((k + czesc) / n) * 1000) / 10;
    }
    return { zdobyte: zdobyte, nastepny: nastepny, brakuje: nastepny ? Math.round((nastepny.prog - suma) * 100) / 100 : 0, procent: Math.min(100, procent), progi: progi };
  }

  /** Okno paska (decyzja Kamila 2026-09-22): zamiast wszystkich progów tylko 3 kropki — ostatni zdobyty próg,
   * następny i kolejny; klient zawsze widzi, że jest jeszcze coś dalej. Odcinek do następnej kropki wypełnia się
   * proporcjonalnie do kwoty. Kropka i stoi na ((i+1)/m)·100 %; przed pierwszą kropką jest odcinek od poprzedniego progu (albo od 0 zł). */
  function okno(suma, konfig, ile) {
    var d = drabinka(suma, konfig), m = ile || 3, k = d.zdobyte.length;
    var start = Math.max(0, Math.min(k - 1, d.progi.length - m));
    var progi = d.progi.slice(start, start + m), n = progi.length;
    if (!n) return { progi: [], procent: 0, zdobyte: 0 };
    var zdob = Math.min(n, k - start);                          // ile kropek w oknie jest zdobytych
    var dolny = zdob ? progi[zdob - 1].prog : (start ? d.progi[start - 1].prog : 0);
    var gorny = zdob < n ? progi[zdob].prog : null;
    var czesc = gorny == null ? 0 : Math.max(0, Math.min(1, (suma - dolny) / (gorny - dolny)));
    var procent = ((zdob + czesc) / n) * 100;
    if (zdob === n) procent = 100;
    return { progi: progi, procent: Math.round(procent * 10) / 10, zdobyte: zdob, nastepny: d.nastepny, brakuje: d.brakuje };
  }

  /** Koniec promocji tygodnia: najbliższy poniedziałek 05:00 UTC (publikacja automatu), chyba że konfiguracja podaje datę. */
  function koniecPromocji(konfig, teraz) {
    if (konfig && konfig.promo_koniec) { var d = new Date(konfig.promo_koniec); if (!isNaN(d)) return d; }
    var t = teraz || new Date();
    var x = new Date(Date.UTC(t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate(), 5, 0, 0));
    var dni = (8 - x.getUTCDay()) % 7;             // 0 = poniedziałek → 7 dni, wt → 6 …
    if (dni === 0 && x <= t) dni = 7;
    x.setUTCDate(x.getUTCDate() + dni);
    return x;
  }
  function licznikTekst(ms) {
    if (ms <= 0) return 'kończy się teraz';
    var s = Math.floor(ms / 1000), d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60);
    return (d ? d + ' dn. ' : '') + h + ' godz. ' + (m < 10 ? '0' : '') + m + ' min';
  }

  var LOGIKA = { stanDocelowy: stanDocelowy, dostepneOpcje: dostepneOpcje, drabinka: drabinka, okno: okno, koniecPromocji: koniecPromocji, licznikTekst: licznikTekst, zl: zl };
  if (typeof module !== 'undefined' && module.exports) { module.exports = LOGIKA; return; }   // testy w Node
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  window.DermesHubPrezent = LOGIKA;

  /* ------------------------------ część przeglądarkowa ------------------------------ */
  var konfig = null;
  try {
    var el = document.getElementById('dermeshub-prezent-konfig');
    konfig = el ? JSON.parse(el.textContent) : null;
  } catch (e) { konfig = null; }
  if (!konfig || !konfig.aktywna || !(konfig.progi || []).length) return;
  var dzis = new Date().toISOString().slice(0, 10);
  if ((konfig.od && dzis < konfig.od) || (konfig.do && dzis > konfig.do)) return;

  var T = Object.assign({
    naglowek: 'Bonusy za zakupy',
    brakuje: 'Dodaj produkty za <b>{kwota}</b> i odbierz <b>{bonus}</b>',
    wszystko: 'Masz wszystkie bonusy w tym zamówieniu!',
    zmieniam: 'Zmieniam prezent…',
    rezygnuj: 'Wolisz kod rabatowy albo punkty lojalnościowe? <a href="#" data-dh-rezygnuj>Zrezygnuj z prezentu</a>',
    zrezygnowano: 'Prezent wyłączony — w kasie możesz użyć kodu rabatowego (próbki zostają). <a href="#" data-dh-przywroc>Przywróć prezent</a>',
    et_probki: 'Próbki', et_dostawa: 'Darmowa dostawa', et_prezenty: 'Prezent Plus|Prezent Premium|Prezent Pro',   // nazwy progów (nie kwoty — „prezent 500 zł" czytano jak wartość)
    et_od: 'od {prog} zł',
    kod: 'Prezent nie łączy się z kodem rabatowym (próbki zostają) — usuń kod, aby dostać prezent.',
    brak_prezentu: 'Prezenty z tego progu chwilowo się wyczerpały — pakiet próbek zostaje w koszyku.',
    wybierz: 'Wybierz prezent za 1 gr:',   // bez kwoty progu — „prezent za 500 zł" czytano jako wartość prezentu (Kamil 2026-09-22)
    licznik: 'Promocja tygodnia kończy się za {czas}',
    // koszt dostawy PRZED kasą (2026-09-25, Clarity: klienci wracali z kasy na stronę główną po tę informację); kwoty = stawki
    // aplikacji InPost w kasie; teksty.dostawa w metapolu nadpisuje, pusty string wyłącza
    dostawa: 'Paczkomat InPost i kurier <b>15 zł</b> · darmowa dostawa od 300 zł · BLIK, karta, PayPal, za pobraniem'
  }, konfig.teksty || {});
  var tekst = function (klucz, dane) { return String(T[klucz] || '').replace(/\{(\w+)\}/g, function (_, k) { return dane[k] != null ? dane[k] : ''; }); };

  var CSS = '.dh-prezent{--dh-akcent:rgb(var(--color-button,204,76,139));margin:0 0 12px;padding:12px 14px;border:1px solid rgba(0,0,0,.08);border-radius:12px;font-size:13px;line-height:1.35;background:#fff;box-shadow:0 2px 10px rgba(0,0,0,.04)}'
    + '.dh-prezent__licznik{font-size:11px;color:#8a8a8a;margin-bottom:6px;letter-spacing:.2px}'
    + '.dh-prezent__info{margin:0;display:flex;align-items:center;gap:8px;font-size:14px;color:#1a1a1a}.dh-prezent__info b{color:var(--dh-akcent);font-weight:700}'
    + '.dh-prezent__rezygnacja{margin:8px 0 0;font-size:11px;color:#8a8a8a}.dh-prezent__rezygnacja a,.dh-prezent__info.is-rezygnacja a{color:inherit;text-decoration:underline}'
    + '.dh-prezent__info.is-rezygnacja{color:#6f625a;font-size:13px}.dh-prezent__info.is-kod{color:#b00020}.dh-prezent__info.is-ok{color:var(--dh-akcent);font-weight:600}.dh-prezent__ikona{flex:none;color:var(--dh-akcent)}'
    + '.dh-prezent__pasek{position:relative;margin:12px 0 40px;padding-right:8px}'
    + '.dh-prezent__tor{height:8px;background:#ececec;border-radius:4px;overflow:hidden}.dh-prezent__wyp{height:100%;background:var(--dh-akcent);border-radius:4px;transition:width .5s ease}'
    + '.dh-prezent__kropka{position:absolute;top:-5px;width:18px;height:18px;margin-left:-9px;border-radius:50%;background:#fff;border:2px solid #d6d6d6;box-sizing:border-box;display:flex;align-items:center;justify-content:center;color:#fff;transition:background .3s,border-color .3s}'
    + '.dh-prezent__kropka.is-on{background:var(--dh-akcent);border-color:var(--dh-akcent)}.dh-prezent__kropka.is-teraz{border-color:var(--dh-akcent)}'
    + '.dh-prezent__et{position:absolute;top:16px;transform:translateX(-50%);text-align:center;font-size:9.5px;line-height:1.15;color:#8a8a8a;display:flex;flex-direction:column;gap:1px}'
    + '.dh-prezent__et b{font-weight:600;color:#8a8a8a;overflow-wrap:anywhere}.dh-prezent__et small{font-size:8.5px;color:#a3a3a3}'
    + '.dh-prezent__et.is-on b{color:var(--dh-akcent)}.dh-prezent__et.is-teraz b{color:#1a1a1a}.dh-prezent__et.is-ostatni{transform:translateX(-88%);text-align:right;align-items:flex-end}'
    + '.dh-prezent__wybor{margin:10px 0 0;font-size:12px;color:#444}.dh-prezent__zmieniam{color:var(--dh-akcent);font-weight:600}'
    + '.dh-prezent__zmieniam:after{content:"";display:inline-block;width:10px;height:10px;margin-left:6px;border:2px solid var(--dh-akcent);border-right-color:transparent;border-radius:50%;animation:dhkr .7s linear infinite;vertical-align:-1px}@keyframes dhkr{to{transform:rotate(360deg)}}'
    + '.dh-prezent__opcje.is-busy{opacity:.75}.dh-prezent__znak{position:absolute;top:6px;right:6px;width:18px;height:18px;border-radius:50%;background:var(--dh-akcent);color:#fff;display:flex;align-items:center;justify-content:center}'
    + '.dh-prezent__opcje{display:grid;grid-template-columns:repeat(auto-fill,minmax(88px,1fr));gap:8px;margin-top:6px}'
    + '.dh-prezent button.dh-prezent__opcja{position:relative;display:flex;flex-direction:column;align-items:center;gap:4px;min-height:0;height:auto;width:100%;margin:0;border:2px solid #e3e3e3;border-radius:10px;padding:8px 6px 6px;background:#fff;cursor:pointer;text-align:center;font:inherit;font-size:11px;line-height:1.2;letter-spacing:0;text-transform:none;color:#222;box-shadow:none;white-space:normal;overflow-wrap:anywhere;transition:border-color .15s,transform .15s}'
    + '.dh-prezent__z{display:block;font-size:9px;color:#a3a3a3;font-weight:400;margin-top:1px}'
    + '.dh-prezent button.dh-prezent__opcja:hover{border-color:#bbb}.dh-prezent button.dh-prezent__opcja:active{transform:scale(.97)}'
    + '.dh-prezent button.dh-prezent__opcja img{width:56px;height:56px;max-width:100%;object-fit:contain;display:block;margin:0;flex:none}'
    + '.dh-prezent button.dh-prezent__opcja.is-on{border-color:var(--dh-akcent);box-shadow:0 0 0 1px var(--dh-akcent);font-weight:600}.dh-prezent button.dh-prezent__opcja[disabled]{cursor:default}'
    + '#dh-prezent-page .dh-prezent__opcje{grid-template-columns:repeat(auto-fill,minmax(150px,1fr));gap:12px}'
    + '#dh-prezent-page button.dh-prezent__opcja{font-size:13px;padding:10px}#dh-prezent-page button.dh-prezent__opcja img{width:110px;height:110px}'
    + '#dh-prezent-page{font-size:14px}#dh-prezent-page .dh-prezent__info{font-size:16px}#dh-prezent-page .dh-prezent__et{font-size:12px;top:18px}#dh-prezent-page .dh-prezent__et small{font-size:10px}#dh-prezent-page .dh-prezent__tor{height:10px}#dh-prezent-page .dh-prezent__kropka{width:22px;height:22px;margin-left:-11px;top:-6px}#dh-prezent-page .dh-prezent__pasek{margin-bottom:48px}'
    + '@media (max-width:767px){#dh-prezent-page .dh-prezent__opcje{grid-template-columns:repeat(auto-fill,minmax(105px,1fr));gap:8px}#dh-prezent-page button.dh-prezent__opcja img{width:72px;height:72px}#dh-prezent-page button.dh-prezent__opcja{font-size:11px;padding:6px}}'
    // telefon (szuflada i strona koszyka): jeden przewijany poziomo rząd dużych kafelków, wybrany przewija się w pole widzenia
    + '@media (max-width:767px){.dh-prezent .dh-prezent__opcje{display:flex;overflow-x:auto;scroll-snap-type:x proximity;gap:8px;padding:2px 2px 6px;margin:6px -2px 0;-webkit-overflow-scrolling:touch;scrollbar-width:none}'
    + '.dh-prezent .dh-prezent__opcje::-webkit-scrollbar{display:none}'
    + '.dh-prezent button.dh-prezent__opcja{flex:0 0 118px;scroll-snap-align:start;font-size:11px;padding:8px 6px 7px;min-height:150px;justify-content:flex-start}'
    + '.dh-prezent button.dh-prezent__opcja img{width:70px;height:70px}}'
    + '.dh-prezent__dostawa{margin:10px 0 0;padding-top:8px;border-top:1px solid rgba(0,0,0,.06);font-size:11px;line-height:1.4;color:#6b6b6b}.dh-prezent__dostawa b{color:#1a1a1a;font-weight:600}'
    + 'free-shipping-goal,.free-shipping-goal{display:none!important}';   // pasek darmowej dostawy motywu zastępuje drabinka + licznik
  if (!document.getElementById('dh-prezent-css')) {
    var st = document.createElement('style'); st.id = 'dh-prezent-css'; st.textContent = CSS; document.head.appendChild(st);
  }

  var zajety = false, ostatniStan = null, ostatniKoszyk = null, dzialania = [], wyborKlienta = null;
  // warianty prezentów, których Shopify teraz nie sprzeda (stan śledzony przez portal, 2026-09-24): z /products/<handle>.js
  // (co najwyżej raz na minutę) i z odmowy dodania do koszyka (422) — takiego prezentu nie wybieramy
  var niedostepne = [], dostepnoscCzas = 0;
  function sprawdzDostepnosc() {
    dostepnoscCzas = Date.now();
    var progi = progiPosortowane(konfig).filter(function (p) { return p.typ === 'prezent'; });
    return Promise.all(progi.map(function (p) {
      return fetch('/products/' + (p.handle || ('dermeshub-prezent-' + p.prog)) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (lista) {
      var nowe = [], znane = {};
      lista.forEach(function (prod) { ((prod && prod.variants) || []).forEach(function (v) { znane[String(v.id)] = true; if (!v.available) nowe.push(String(v.id)); }); });
      niedostepne.forEach(function (id) { if (!znane[id] && nowe.indexOf(id) < 0) nowe.push(id); });   // odmowy 422 dla wariantów spoza odpowiedzi zostają
      var zmiana = nowe.slice().sort().join(',') !== niedostepne.slice().sort().join(',');
      niedostepne = nowe;
      if (zmiana && ostatniKoszyk && !zajety) synchronizuj(ostatniKoszyk);
    });
  }
  // rezygnacja z prezentu (klient chce użyć kodu/punktów w kasie — kasa Shopify odrzuca kod, gdy działa rabat automatyczny)
  function rezygnacja(ustaw) {
    try { if (ustaw === true) sessionStorage.setItem('dh_bez_prezentu', '1'); else if (ustaw === false) sessionStorage.removeItem('dh_bez_prezentu'); return sessionStorage.getItem('dh_bez_prezentu') === '1'; }
    catch (e) { return false; }
  }
  function zaDuzo() {   // bezpiecznik pętli: max 8 zapisów w 20 s
    var t = Date.now(); dzialania = dzialania.filter(function (x) { return t - x < 20000; });
    return dzialania.length >= 8;
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }
  function sekcjeKoszyka() {
    var ids = [];
    Array.prototype.forEach.call(document.querySelectorAll('cart-items, cart-drawer'), function (el) {
      var id = null;
      try { if (window.FoxTheme && FoxTheme.utils && FoxTheme.utils.getSectionId) id = FoxTheme.utils.getSectionId(el); } catch (e) { id = null; }
      if (!id) { var s = el.closest('.shopify-section'); id = el.getAttribute('data-section-id') || (s && s.id ? s.id.replace(/^shopify-section-/, '') : null); }
      if (id && ids.indexOf(id) < 0) ids.push(id);
    });
    return ids;
  }
  function odswiez() {
    var FT = window.FoxTheme, ids = sekcjeKoszyka();
    if (FT && FT.pubsub && FT.pubsub.PUB_SUB_EVENTS && ids.length) {
      // jak motyw przy zmianie ilości: /cart/update.js z listą sekcji → publikacja cart-update z gotowym HTML-em sekcji
      return post('/cart/update.js', { sections: ids.join(','), sections_url: window.location.pathname })
        .then(function (cart) { if (cart && cart.items) FT.pubsub.publish(FT.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart }); })
        .catch(function () { try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } })); } catch (e) { /* */ } });
    }
    try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } })); }
    catch (e) { /* stary motyw */ }
    return Promise.resolve();
  }
  function synchronizuj(cart) {
    if (!cart || !cart.items) return;
    ostatniKoszyk = cart;
    var kody = ((cart.discount_codes || []).filter(function (c) { return c && c.applicable !== false; }).map(function (c) { return String(c.code).toUpperCase(); }).sort().join(','));
    var odrzucone = false;
    try { odrzucone = !!kody && sessionStorage.getItem('dh_probki_odrzucone') === kody; } catch (e) { /* */ }
    if (Date.now() - dostepnoscCzas > 60000) sprawdzDostepnosc();
    var stan = stanDocelowy(cart, konfig, wyborKlienta, { rezygnacja: rezygnacja(), probkiOdrzucone: odrzucone, niedostepne: niedostepne });
    if (stan.probki_odrzucone) { try { sessionStorage.setItem('dh_probki_odrzucone', kody); } catch (e) { /* */ } }
    ostatniStan = stan;
    rysuj(stan, cart);
    var akcje = stan.ilosc.length + stan.usun.length + stan.dodaj.length;
    if (!akcje || zajety) return;
    if (zaDuzo()) { if (window.console) console.warn('dermesHub prezent: za dużo zmian koszyka, przerywam'); return; }
    zajety = true; dzialania.push(Date.now());
    rysuj(stan, cart);   // od razu: wybrany kafelek podświetlony, „Zmieniam prezent…"
    // JEDEN request (2026-09-22, wcześniej 3–4 i ok. 2 s bez reakcji): updates = klucz linii → ilość (0 = usuń),
    // id wariantu → 1 (dodaje, gdy nie ma), sections = gotowy HTML sekcji koszyka do przerysowania jak w motywie
    var updates = {};
    stan.ilosc.forEach(function (z) { updates[z.key] = z.quantity; });
    stan.usun.forEach(function (key) { updates[key] = 0; });
    stan.dodaj.forEach(function (d) { updates[String(d.id)] = 1; });
    var FT = window.FoxTheme, ids = sekcjeKoszyka();
    post('/cart/update.js', { updates: updates, sections: ids.join(','), sections_url: window.location.pathname })
      .then(function (c) {
        if (!c || !c.items) throw new Error(c && (c.description || c.message) || 'update.js');
        var brak = stan.dodaj.filter(function (d) { return !c.items.some(function (it) { return String(it.variant_id) === String(d.id); }); });
        if (brak.length) {   // gdyby update.js nie dodał nowych wariantów — klasyczna ścieżka
          return post('/cart/add.js', { items: brak.map(function (d) { return { id: d.id, quantity: 1 }; }) }).then(function () { zajety = false; wyborKlienta = null; return odswiez(); });
        }
        zajety = false; wyborKlienta = null;
        if (FT && FT.pubsub && FT.pubsub.PUB_SUB_EVENTS && c.sections) FT.pubsub.publish(FT.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: c });
        else return odswiez();
      })
      .catch(function (e) {
        zajety = false; wyborKlienta = null; if (window.console) console.warn('dermesHub prezent:', e);
        // Shopify odmówił (np. 422: prezent się wyczerpał) — te prezenty wypadają z wyboru, przy następnym przebiegu wchodzi kolejny
        var mapa = mapaWariantow(konfig);
        stan.dodaj.forEach(function (d) { var m = mapa[String(d.id)]; if (m && m.typ === 'prezent' && niedostepne.indexOf(String(d.id)) < 0) niedostepne.push(String(d.id)); });
        odswiez();
      });
  }
  function wybierz(wariant) {
    wyborKlienta = wariant;
    if (ostatniKoszyk) synchronizuj(ostatniKoszyk);
  }

  // Szuflada: id sekcji na żywej stronie ma prefiks (CartDrawerBody-sections--…__cart-drawer), więc szukamy po początku id.
  // Motyw podmienia innerHTML tego elementu przy każdej zmianie — pasek wstawiamy PRZED nim (rodzic zostaje).
  function miejsca() {
    var out = [];
    var drawerBody = document.querySelector('cart-drawer [id^="CartDrawerBody-"]');
    if (drawerBody && drawerBody.parentNode) out.push({ id: 'dh-prezent-drawer', rodzic: drawerBody.parentNode, przed: drawerBody.parentNode.firstElementChild });
    var strona = document.querySelector('cart-items');
    if (strona && strona.parentNode && !strona.closest('cart-drawer')) out.push({ id: 'dh-prezent-page', rodzic: strona.parentNode, przed: strona });
    return out;
  }
  // Pozycje prezentowe na KONIEC listy (Shopify stawia nowe pozycje na początku koszyka)
  // Pozycje prezentowe na KONIEC listy; przy zwykłych pozycjach motyw pokazuje plakietkę rabatu z kwotą 0
  // (Shopify oznacza nimi pozycje „X" progu) — zdejmujemy ją, żeby nie mylić klienta
  function wariantLinii(li) {
    var v = li.getAttribute('data-variant-id');
    if (v) return String(v);
    var a = li.querySelector('a[href*="/cart/change?id="]');
    var m = a && /[?&]id=(\d+)/.exec(a.getAttribute('href') || '');
    return m ? m[1] : null;
  }
  // Idempotentnie: gdy prezenty już są na końcu listy (w dowolnej kolejności), nic nie ruszamy. Wcześniej dwie pozycje
  // prezentowe zamieniały się miejscami w kółko, każda zamiana budziła obserwator → migotanie i blokada „+/−" (telefon Kamila).
  var wlasnaZmiana = false;
  function prezentyNaKoniec() {
    var mapa = mapaWariantow(konfig), wz = /^\s*(Prezent\b|Pakiet próbek)/, listy = [];
    wlasnaZmiana = true;
    try {
      Array.prototype.forEach.call(document.querySelectorAll('.cart-item'), function (li) {
        var wv = wariantLinii(li);
        if (!wv || !mapa[wv]) {
          Array.prototype.forEach.call(li.querySelectorAll('.cart-item__discounts .discount, .discounts .discount'), function (b) { if (wz.test(b.textContent)) b.parentNode.removeChild(b); });
          return;
        }
        var ul = li.parentNode; if (!ul) return;
        var w = null; for (var i = 0; i < listy.length; i++) if (listy[i].ul === ul) w = listy[i];
        if (!w) { w = { ul: ul, prezenty: [] }; listy.push(w); }
        w.prezenty.push(li);
      });
      listy.forEach(function (w) {
        var dzieci = Array.prototype.slice.call(w.ul.children), n = w.prezenty.length;
        var ogon = dzieci.slice(dzieci.length - n), juz = ogon.length === n && ogon.every(function (el) { return w.prezenty.indexOf(el) >= 0; });
        if (!juz) w.prezenty.forEach(function (li) { w.ul.appendChild(li); });
      });
    } finally { setTimeout(function () { wlasnaZmiana = false; }, 0); }
  }
  var IKONA = '<svg class="dh-prezent__ikona" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 12v9H4v-9"/><path d="M2 7h20v5H2z"/><path d="M12 21V7"/><path d="M12 7s-1.5-4-4-4a2 2 0 0 0 0 4"/><path d="M12 7s1.5-4 4-4a2 2 0 0 1 0 4"/></svg>';
  var PTASZEK = '<svg viewBox="0 0 16 16" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 8.5l3 3 7-7"/></svg>';
  function etykietaProgu(prog) { var p = progiPosortowane(konfig).filter(function (x) { return x.prog === prog; })[0]; return p ? etykieta(p) : prog + ' zł'; }
  function etykieta(p) {
    if (p.krotki) return p.krotki;
    if (p.typ === 'probki') return T.et_probki;
    if (p.typ === 'dostawa') return T.et_dostawa;
    var prezenty = progiPosortowane(konfig).filter(function (x) { return x.typ === 'prezent'; }), nazwy = String(T.et_prezenty).split('|');
    var i = prezenty.indexOf(p);
    return nazwy[i] || ('Prezent ' + (i + 1));
  }
  function html(stan, cart) {
    var d = drabinka(stan.suma, konfig), h = '', n = d.progi.length, k = d.zdobyte.length;
    if (konfig.licznik !== false) h += '<div class="dh-prezent__licznik" data-dh-licznik>' + tekst('licznik', { czas: licznikTekst(koniecPromocji(konfig) - new Date()) }) + '</div>';
    if (stan.kod) h += '<p class="dh-prezent__info is-kod">' + T.kod + '</p>';
    else if (stan.rezygnacja) h += '<p class="dh-prezent__info is-rezygnacja">' + T.zrezygnowano + '</p>';
    else if (d.nastepny) h += '<p class="dh-prezent__info">' + IKONA + '<span>' + tekst('brakuje', { kwota: zl(d.brakuje), bonus: esc(etykieta(d.nastepny)) }) + '</span></p>';
    else h += '<p class="dh-prezent__info is-ok">' + IKONA + '<span>' + T.wszystko + '</span></p>';
    // okno 3 kropek (ostatni zdobyty, następny, kolejny); odcinek do następnej kropki rośnie z kwotą w koszyku
    var o = okno(stan.suma, konfig, 3), m = o.progi.length;
    h += '<div class="dh-prezent__pasek"><div class="dh-prezent__tor"><div class="dh-prezent__wyp" style="width:' + o.procent + '%"></div></div>';
    o.progi.forEach(function (p, i) {
      var x = ((i + 1) / m) * 100, kl = i < o.zdobyte ? ' is-on' : i === o.zdobyte ? ' is-teraz' : '';
      h += '<span class="dh-prezent__kropka' + kl + '" style="left:' + x + '%">' + (i < o.zdobyte ? PTASZEK : '') + '</span>'
        + '<span class="dh-prezent__et' + kl + (i === m - 1 ? ' is-ostatni' : '') + '" style="left:' + x + '%;width:' + (100 / m) + '%"><b>' + esc(etykieta(p)) + '</b><small>' + tekst('et_od', { prog: p.prog }) + '</small></span>';
    });
    h += '</div>';
    if (!stan.kod && !stan.rezygnacja && stan.brak_prezentu) h += '<p class="dh-prezent__wybor">' + T.brak_prezentu + '</p>';
    else if (!stan.kod && stan.osiagniety) {
      var prog = d.progi.filter(function (p) { return p.typ === 'prezent' && p.prog === stan.osiagniety; })[0];
      var opcjeDo = prog ? dostepneOpcje(prog, niedostepne) : [];
      if (opcjeDo.length > 1) {
        var wybrany = zajety && wyborKlienta ? Number(wyborKlienta) : stan.wybrany;
        h += '<p class="dh-prezent__wybor">' + tekst('wybierz', { prog: prog.prog }) + (zajety ? ' <span class="dh-prezent__zmieniam">' + T.zmieniam + '</span>' : '') + '</p><div class="dh-prezent__opcje' + (zajety ? ' is-busy' : '') + '">';
        opcjeDo.forEach(function (o) {
          h += '<button type="button" class="dh-prezent__opcja' + (Number(o.wariant) === wybrany ? ' is-on' : '') + '" data-dh-wariant="' + Number(o.wariant) + '"' + (zajety ? ' disabled' : '') + '>'
            + (o.obraz ? '<img src="' + esc(o.obraz) + '" alt="" loading="lazy">' : '') + '<span>' + esc(o.tytul || o.sku || '') + '</span>'
            + (o.z ? '<small class="dh-prezent__z">' + esc(etykietaProgu(o.z)) + '</small>' : '') + (Number(o.wariant) === wybrany ? '<i class="dh-prezent__znak">' + PTASZEK + '</i>' : '') + '</button>';
        });
        h += '</div>';
      }
    }
    if (!stan.kod && !stan.rezygnacja && (stan.osiagniety || stan.probki)) h += '<p class="dh-prezent__rezygnacja">' + T.rezygnuj + '</p>';
    if (T.dostawa) h += '<p class="dh-prezent__dostawa">' + T.dostawa + '</p>';
    return h;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  var ostatniHtml = {};
  function rysuj(stan, cart) {
    var tresc = html(stan, cart);
    miejsca().forEach(function (m) {
      var box = document.getElementById(m.id);
      wlasnaZmiana = true;
      if (!box) { box = document.createElement('div'); box.id = m.id; box.className = 'dh-prezent'; m.rodzic.insertBefore(box, m.przed || null); ostatniHtml[m.id] = null; }
      if (ostatniHtml[m.id] !== tresc || !box.firstChild) {
        box.innerHTML = tresc; ostatniHtml[m.id] = tresc;   // bez zmian = bez przerysowania (zdjęcia nie migają)
        var wyb = box.querySelector('.dh-prezent__opcja.is-on'), lista = wyb && wyb.parentNode;
        if (wyb && lista && lista.scrollWidth > lista.clientWidth) lista.scrollLeft = Math.max(0, wyb.offsetLeft - lista.offsetLeft - 8);   // telefon: wybrany kafelek w polu widzenia
      }
    });
    prezentyNaKoniec();
  }
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    var r = t.closest('[data-dh-rezygnuj]'), p = t.closest('[data-dh-przywroc]'), b = t.closest('[data-dh-wariant]');
    if (r) { e.preventDefault(); rezygnacja(true); if (ostatniKoszyk) synchronizuj(ostatniKoszyk); return; }
    if (p) { e.preventDefault(); rezygnacja(false); if (ostatniKoszyk) synchronizuj(ostatniKoszyk); return; }
    if (!b) return;
    e.preventDefault(); wybierz(Number(b.getAttribute('data-dh-wariant')));
  });
  setInterval(function () {
    var t = tekst('licznik', { czas: licznikTekst(koniecPromocji(konfig) - new Date()) });
    Array.prototype.forEach.call(document.querySelectorAll('[data-dh-licznik]'), function (el) { el.textContent = t; });
  }, 30000);

  // Zdarzenia motywu Hyper (FoxTheme.pubsub) — z zapasem na cart:updated, gdy pubsub niedostępny
  var FT = window.FoxTheme;
  if (FT && FT.pubsub && FT.pubsub.subscribe && FT.pubsub.PUB_SUB_EVENTS) {
    FT.pubsub.subscribe(FT.pubsub.PUB_SUB_EVENTS.cartUpdate, function (ev) { if (ev && ev.cart && !ev.cart.errors) synchronizuj(ev.cart); });
  } else {
    document.addEventListener('cart:updated', function (ev) { if (ev.detail && ev.detail.cart) synchronizuj(ev.detail.cart); });
  }
  // po każdej podmianie listy pozycji przez motyw: dorysuj pasek (gdy zniknął) i przesuń prezenty na koniec
  var rysujTimer = null;
  function dorysuj() { clearTimeout(rysujTimer); rysujTimer = setTimeout(function () { if (ostatniStan) rysuj(ostatniStan, ostatniKoszyk); }, 150); }
  // obserwujemy CAŁE body: na stronie /cart motyw podmienia sam element <cart-items>, więc obserwator zawieszony na nim
  // milkł po pierwszej zmianie (pasek znikał, prezenty zostawały u góry — test Kamila 2026-09-22)
  if (window.MutationObserver) {
    var obs = new MutationObserver(function (m) {
      if (wlasnaZmiana) return;   // nasze własne przesunięcia i przerysowania nie budzą kolejnego przebiegu
      for (var i = 0; i < m.length; i++) {
        var t = m[i].target;
        if (!t || !t.closest || t.closest('.dh-prezent')) continue;
        if (t.closest('cart-drawer, cart-items, .shopify-section') ) { dorysuj(); return; }
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }
  document.addEventListener('cart:refresh', function () { setTimeout(dorysuj, 600); });
  fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(synchronizuj).catch(function () {});
})();
